import React from 'react';
import { Link } from 'react-router-dom';

import '@app/scss/components/faqBlockHeaderSm.scss';

interface FaqBlockHeaderProps {
	title: string;
	btnText: string;
	clickUrl: string;
}

const FaqBlockHeader: React.FC<FaqBlockHeaderProps> = ({ title, btnText, clickUrl }) => {
	return (
		<div className="faq-block-header-sm">
			<h2>{title}</h2>
			<Link to={clickUrl}>
				<button className="btn btn-primary btn-md">{btnText}</button>
			</Link>
		</div>
	);
};

export default FaqBlockHeader;
